import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  shadows: Array(25).fill("none"),
  typography: {
    fontFamily: "Proximanova Reg, sans-serif",
    button: {
      textTransform: "none",
      backgroundColor: "white",
      color: "#ffffff",
      borderRadius: "5px",
    },
  },
  autocomplete: {
    maxWidth: window.innerWidth < 750 ? "90%" : "350px",
    minWidth: window.innerWidth < 750 ? "90%" : "250px",
  },
  palette: {
    primary: {
      main: "#0A4595",
    },
    secondary: {
      main: "#f50057",
    },
  },
});

export default theme;
